import { render } from "./WidgetPanel.vue?vue&type=template&id=1f0a1072&scoped=true"
import script from "./WidgetPanel.vue?vue&type=script&lang=js"
export * from "./WidgetPanel.vue?vue&type=script&lang=js"

import "./WidgetPanel.vue?vue&type=style&index=0&id=1f0a1072&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0a1072"]])

export default __exports__